import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { Table } from 'components';

/**
 * Keeps a wide table inside the page on a narrow desktop instead of pushing the
 * whole layout sideways. Only above the breakpoint where the table is still a
 * table — below it every row is stacked and there is nothing to scroll.
 */
export const TableScroll = styled.div`
  ${breakpoint('lg')`
    overflow-x: auto;
  `}
`;

export const RegRow = styled(Table.Row)`
  &:nth-of-type(even) {
    background-color: unset;
  }
  background-color: ${({ isOdd }) => (isOdd ? '#fff' : '#fbfbfb')} !important;

  > td {
    vertical-align: middle;
    font-size: 14px !important;
  }
  > td:first-child {
    font-size: 16px !important;
  }
`;

export const RegOrgRow = styled(RegRow)`
  border-top: 1px solid #d3d3d6;
  > td:first-child {
    font-size: 14px !important;
  }
`;

/**
 * Closes off one member association's courses with its totals. Tinted and ruled
 * off the top so the eye reads it as the end of a block rather than as another
 * course.
 */
export const RegSubtotalRow = styled(Table.Row)`
  &:nth-of-type(even) {
    background-color: unset;
  }
  background-color: #f1f1f4 !important;
  border-top: 1px solid #d3d3d6;

  > td {
    vertical-align: middle;
    font-size: 14px !important;
    font-weight: 600;
    color: #4f4e5c;
  }
`;

/** The same, for the last row of all: every member association together. */
export const RegTotalRow = styled(RegSubtotalRow)`
  background-color: #e4e4ea !important;
  border-top: 2px solid #b6b6bd;

  > td {
    font-weight: 700;
  }
`;
